"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
var _auth = require("@/utils/auth");
var _router = require("@/router");
//import { login, logout, getInfo } from '@/api/login'

var getDefaultState = function getDefaultState() {
  return {
    token: (0, _auth.getToken)(),
    name: '',
    avatar: '',
    menus: undefined,
    userId: ''
  };
};
var state = getDefaultState();
var mutations = {
  RESET_STATE: function RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_MENUS: function SET_MENUS(state, menus) {
    state.menus = menus;
  },
  SET_USERID: function SET_USERID(state, userId) {
    state.userId = userId;
  }
};
var actions = {
  // user login
  // login({ commit }, userInfo) {
  //   commit('SET_TOKEN', '')
  //   return new Promise((resolve, reject) => {
  //     login(userInfo)
  //       .then(response => {
  //         commit('SET_TOKEN', response.data)
  //         setToken(response.data)
  //         resolve(response)
  //       })
  //       .catch(error => {
  //         reject(error)
  //       })
  //   })
  // },
  // get user info
  // getInfo({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getInfo(state.token)
  //       .then(response => {
  //         const data = response
  //         commit('SET_NAME', data.name)
  //         commit('SET_USERID', data.id)
  //         commit('SET_AVATAR', 'http://git.oschina.net/uploads/42/547642_geek_qi.png?1499487420')
  //         const menus = {}
  //         if (data.menus && JSON.stringify(data.menus) !== '[]') {
  //           for (let i = 0; i < data.menus.length; i++) {
  //             menus[data.menus[i].code] = true
  //           }
  //         }
  //         commit('SET_MENUS', menus)
  //         /* const elements = {}
  //       for (let i = 0; i < data.elements.length; i++) {
  //         elements[data.elements[i].code] = true
  //       }
  //       commit('SET_ELEMENTS', elements) */
  //         resolve(response)
  //       })
  //       .catch(error => {
  //         reject(error)
  //       })
  //   })
  // },
  // user logout
  // logout({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     logout(state.token)
  //       .then(() => {
  //         removeToken() // must remove  token  first
  //         resetRouter()
  //         commit('RESET_STATE')
  //         resolve()
  //       })
  //       .catch(error => {
  //         reject(error)
  //       })
  //   })
  // },
  // remove token
  resetToken: function resetToken(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      (0, _auth.removeToken)(); // must remove  token  first
      commit('RESET_STATE');
      resolve();
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};